import React from 'react';
import { isEmpty } from 'lodash/fp';
import { List } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { matchPath, useLocation } from 'react-router-dom';
import { GetInitInfoQuery, useGetInitInfoQuery } from '../generated/graphql';
import { checkAccess, checkVenueTypeAccess } from '../utils';
import { useUser } from '../utils/hooks/auth';
import ListItemLink from './ListItemLink';
import { SidebarLinksProps } from './types';
import SidebarCollapsibleListItem from './SidebarCollapsibleListItem';

const SidebarLinks = ({ routes, onClick, onCollapsibleClick, isDrawerOpen }: SidebarLinksProps) => {
    const { t } = useTranslation();
    const { data } = useGetInitInfoQuery({ fetchPolicy: 'cache-only' });
    const { user: { venueType } } = useUser();
    const { employeePermissions } = data as GetInitInfoQuery;

    const { pathname } = useLocation();

    return (
        <List>
            {routes.map(route => {
                const { path, icon, title, childrenRoutes = [] } = route;

                const primaryRouteTitle = t(...title);
                const { permissions, allowedVenueTypes } = route;

                const hasAccess = checkVenueTypeAccess(allowedVenueTypes, venueType) && checkAccess(permissions, employeePermissions);

                if (!hasAccess) {
                    return null;
                }

                const childenRoutesToRender = childrenRoutes.filter(({ showInSideBar }) => showInSideBar);
                if (!isEmpty(childenRoutesToRender)) {
                    return (
                        <SidebarCollapsibleListItem
                            isDrawerOpen={isDrawerOpen}
                            key={primaryRouteTitle}
                            onCollapsibleClick={onCollapsibleClick}
                            route={{
                                ...route,
                                childrenRoutes: childenRoutesToRender,
                            }}
                            onRouteClick={onClick}
                        />
                    );
                }

                const match = matchPath(pathname, { path });

                return (
                    <ListItemLink
                        key={primaryRouteTitle}
                        active={!!match}
                        to={path}
                        primary={primaryRouteTitle}
                        onClick={onClick}
                        icon={icon}
                    />
                );
            })}
        </List>
    );
};

export default SidebarLinks;
